import I18N from '@leverege/i18n';
import EditSettingsAction from "../../actions/EditSettingsAction.js";
const {
  tf
} = I18N.ns('molten.dataViewers.history.EditSettingsAction');
export default new EditSettingsAction({
  id: 'molten.dataViewers.history.EditSettingsAction',
  matches: {
    use: 'actionBar',
    client: 'HistoryView'
  },
  title: tf('title'),
  versionType: opts => {
    return 'historyModel';
  },
  editorProps: opts => {
    const {
      context
    } = opts;
    const {
      clientProps
    } = context;
    const {
      objectType,
      delegate,
      relationship,
      dataViewerCardModel,
      parentItem
    } = clientProps;
    return {
      objectType,
      delegate,
      relationship,
      dataViewerCardModel,
      parentItem
    };
  }
});